import * as actionTypes from '../actions/actionTypes';
import STATUS from '../actions/constants';

const initialState = {
  status: STATUS.IDLE,
  error: null,
  projects: [],
};

const projetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PROJECTS_INIT:
      return {
        ...state,
        status: STATUS.LOADING,
        error: null,
      };
    case actionTypes.GET_PROJECTS_SUCCESS:
      return {
        ...state,
        status: STATUS.SUCCEEDED,
        projects: action.payload,
        error: null,
      };
    case actionTypes.GET_PROJECTS_ERROR:
      return {
        ...state,
        status: STATUS.FAILED,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default projetsReducer;
